import { render, staticRenderFns } from "./VModal.vue?vue&type=template&id=bc305484&"
import script from "./VModal.vue?vue&type=script&lang=js&"
export * from "./VModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports